// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export function reloadApp(): void {
  window.location.reload();
}
